import { render, staticRenderFns } from "./BoxQueueTable.vue?vue&type=template&id=b05d0442&scoped=true&"
import script from "./BoxQueueTable.vue?vue&type=script&lang=js&"
export * from "./BoxQueueTable.vue?vue&type=script&lang=js&"
import style0 from "./BoxQueueTable.vue?vue&type=style&index=0&id=b05d0442&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05d0442",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QTable,QInput,QTd,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon,QTooltip,QTable,QInput,QTd,QInnerLoading,QSpinnerTail})
